<template>
    <div class="member-wrapper">
        <div class="member-item" @click="$emit('click', item)">
            <img class="avatar" :src="item.avatarUrl ? item.avatarUrl : 'https://staticwecom.beautyfarm.com.cn/wecom-workbench/2022-07-06/headPortrait.png'" alt="avatar" />
            <div class="info">
                <div class="name">{{ item.empName }}</div>
                <div class="role">{{ item.postName }}</div>
            </div>
        </div>
        <div class="divider" />
    </div>
</template>

<script>
    export default {
        name: 'StoreMemberItem',
        props: {
            item: { type: Object, required: true }
        }
    }
</script>

<style scoped lang="less">
    .member-wrapper {
        width: 100%;
    }

    .member-item {
        display: flex;
        align-items: center;
        padding: 22px 30px;
    }

    .avatar {
        width: 78px;
        height: 78px;
        border-radius: 12px;
        object-fit: cover;
    }

    .info {
        margin-left: 20px;
        display: flex;
        flex-direction: column;
    }

    .name {
        font-size: 28px;
        color: #35434c;
    }

    .role {
        font-size: 24px;
        color: #a0acb5;
        margin-top: 6px;
    }

    .divider {
        margin: 0 30px;
        height: 1px;
        background: #e8e8e8;
    }
</style>